import { Clock } from 'lucide-react';

interface PendingRegistrationStatusProps {
  message: string;
}

const PendingRegistrationStatus: React.FC<PendingRegistrationStatusProps> = ({
  message,
}) => {
  return (
    <div className="w-full h-full bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 flex items-center justify-center p-4">
      <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-3xl p-8 sm:p-12 lg:p-16 max-w-4xl mx-auto">
        <div className="text-center text-white">
          <Clock className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 mx-auto mb-4 text-blue-400" />
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-8 text-blue-200">
            Device Pending
          </h1>

          <div className="mb-8">
            <h2 className="text-lg sm:text-xl lg:text-2xl font-bold mb-6 text-blue-200">
              Your device is registered but content has not been assigned.
            </h2>
            
         
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingRegistrationStatus;
